
import ServicePageLayout from "@/components/ServicePageLayout";
import StyledBulletPoint from "@/components/StyledBulletPoint";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const SoinEnergetique = () => {
  const openCalendly = () => {
    window.open("https://calendly.com/meneora/soinenergetiquepro", "_blank");
  };

  return (
    <ServicePageLayout
      heroImage="/lovable-uploads/7a03015c-8263-4d46-94a2-1647d315ab39.png"
      heroAlt="Soin énergétique pour thérapeute à Étampes ou en visio"
      heroTitle="Soin énergétique – réalignement & recharge pour thérapeutes"
      heroText="Un soin vibratoire pour revenir à ton axe, nettoyer les charges, et réintégrer ta souveraineté énergétique."
    >
      {/* Pour qui section */}
      <section className="mb-16 reveal-on-scroll">
        <div className="max-w-4xl mx-auto">
          <h2 className="section-title text-center mb-8">Tu accompagnes… et ton énergie aussi a besoin d'être accompagnée</h2>
          <p className="text-xl mb-6 text-foreground/80 text-center">
            Ce soin est destiné aux praticiens, thérapeutes, soignants, coachs…
          </p>
          <div className="space-y-3 mt-8">
            <StyledBulletPoint>Tu te sens vidé, dispersé ou en surcharge</StyledBulletPoint>
            <StyledBulletPoint>Tu veux te réaligner vibratoirement</StyledBulletPoint>
            <StyledBulletPoint>Tu veux accueillir à nouveau ta pratique avec fluidité</StyledBulletPoint>
          </div>
        </div>
      </section>

      {/* Déroulé section */}
      <section className="mb-16 reveal-on-scroll">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="section-title mb-6">Une expérience sacrée, personnalisée, vivante</h2>
            <p className="mb-6 text-foreground/80">
              Chaque soin commence par un temps d'échange. Nous posons ensemble une intention vibratoire claire.
            </p>
            <p className="mb-4 text-foreground/80">Puis :</p>
            <div className="space-y-3 mb-6">
              <StyledBulletPoint>Je canalise des chants</StyledBulletPoint>
              <StyledBulletPoint>Je joue du bol</StyledBulletPoint>
              <StyledBulletPoint>Je pose parfois mes mains (avec ton accord)</StyledBulletPoint>
              <StyledBulletPoint>Tu peux t'exprimer à tout moment</StyledBulletPoint>
            </div>
            <p className="text-foreground/80">
              Clôture du soin par intégration douce et retour possible sur ce qui a été libéré.
            </p>
          </div>
          <div>
            <img 
              src="/lovable-uploads/7a03015c-8263-4d46-94a2-1647d315ab39.png" 
              alt="Soin énergétique en cours avec chant et bol – accompagnement vibratoire" 
              className="rounded-lg shadow-md w-full"
            />
          </div>
        </div>
      </section>

      {/* Réservation section */}
      <section className="bg-accent/10 p-8 rounded-lg reveal-on-scroll">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="section-title mb-4">Prendre rendez-vous</h2>
          <p className="text-xl mb-8">
            Durée : 1h – Tarif : 80 € – En visio ou à Étampes
          </p>
          <Button size="lg" onClick={openCalendly}>
            Réserver
          </Button>
        </div>
      </section>
    </ServicePageLayout>
  );
};

export default SoinEnergetique;
